import "./TestIcdCodesComponent.scss";
import FormTitleWithNavigationBack
    from "../../../../shared/components/form-title-with-navigation-back/FormTitleWithNavigationBack";
import React, {useCallback, useEffect, useRef, useState} from "react";
import * as Yup from "yup";
import {Field, FieldProps, Form, Formik, FormikHelpers, FormikProps, FormikValues} from "formik";
import {Grid} from "@material-ui/core";
import ButtonComponent from "../../../../shared/components/core/button/ButtonComponent";
import _ from "lodash";
import {CommonService} from "../../../../shared/services";
import FormikRadioButtonGroupComponent
    from "../../../../shared/components/core/formik-radio-button-group/formikRadioButtonGroupComponent";
import SearchComponent from "../../../../shared/components/search/SearchComponent";
import DrawerComponent from "../../../../shared/components/drawer/drawerComponent";
import TableWrapperV2Component
    from "../../../../shared/components/table-components/table-wrapper-v2/TableWrapperV2Component";
import {APIConfig} from "../../../../constants";
import {ITableColumn} from "../../../../shared/models/table.model";
import CheckboxComponent from "../../../../shared/components/core/checkbox/CheckboxComponent";
import HeadingComponent from "../../../../shared/components/heading/headingComponent";
import TableV2Component from "../../../../shared/components/table-components/table-v2/TableV2Component";
import {DeleteForever} from "@mui/icons-material";

interface TestIcdCodesComponentProps {
    next: Function;
    cancel: Function;
    testID: number;
    prev: Function;
    testDetails: any;
}

const testIcdValidationSchema = Yup.object().shape({
    isIcdCodeRequired: Yup.boolean().required(),
    searchString: Yup.string(),
    icdCodes: Yup.array().when('isIcdCodeRequired', {
        is: true,
        then: Yup.array()
            .of(Yup.number().required())
            .min(1, "Select at least one ICD")
            .required("Select ICD"),
        otherwise: Yup.array()
    })
});

interface testIcdCodeSchema {
    isIcdCodeRequired: boolean,
    searchString: string,
    icdCodes: number[]
}

const testIcdInitialValues: testIcdCodeSchema = {
    isIcdCodeRequired: false,
    searchString: "",
    icdCodes: []
}

const TestIcdCodesComponent = (props: TestIcdCodesComponentProps) => {
    const {cancel, next, testID, prev, testDetails} = props;
    const [initialFormValue, setInitialFormValue] = useState<FormikValues>(testIcdInitialValues)
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [selectedIcdList, setSelectedIcdList] = useState<any[]>([]);

    const [drawerTableFilter, setDrawerTableFilter] = useState({
        search: ""
    })

    const formikRef = useRef<FormikProps<FormikValues>>(null);

    const columns: ITableColumn[] = [
        {
            id: 'select',
            label: <></>,
            hideInColumnPreferences: true,
            isDefaultColumn: true,
            fixed: "left",
            width: '50',
            content: (item: any) => (
                <CheckboxComponent
                    name={"sample_select"}
                    size={"small"}
                    // disabled={sendOutApplicableSamples?.findIndex((sample: ISample) => sample.id === item.id) === -1}
                    disableRipple={true}
                    checked={selectedIcdList?.findIndex((sample: any) => sample?.id === item?.id) > -1}
                    onUpdate={(isChecked: boolean) => {
                        handleSelectDeselectSample(isChecked, item);
                    }}/>
            )
        },
        {
            id: "icdCode",
            label: "ICD Code",
            width: 100,
            isDefaultColumn: true, align: "center"
        },
        {
            id: "description",
            label: "Description",
            width: 300,
            isDefaultColumn: true, align: "left"
        },
    ]

    const selectedTableColumns: ITableColumn[] = [
        {
            id: "icdCode",
            label: "ICD Code",
            width: 100,
            isDefaultColumn: true, align: "center"
        },
        {
            id: "description",
            label: "Description",
            width: 300,
            isDefaultColumn: true, align: "left"
        },
        {
            id: 'action',
            label: "Action",
            hideInColumnPreferences: true,
            isDefaultColumn: true,
            width: '50',
            content: (item: any) => (
                <ButtonComponent
                    color={"error"}
                    variant={"icon"}
                    handleClick={() => {
                        const selectedIcdlistAfterDelete = selectedIcdList.filter((icd: any) => icd.id !== item.id);
                        const icdCodesAfterDelete = selectedIcdlistAfterDelete.map((icd: any) => icd.id)
                        formikRef.current?.setFieldValue("icdCodes", icdCodesAfterDelete)
                        setSelectedIcdList(selectedIcdlistAfterDelete)
                    }}
                >
                    <DeleteForever/>
                </ButtonComponent>
            )
        }
    ]

    const handleSelectDeselectSample = useCallback((isChecked: boolean, icdCode: any) => {
        const updatedSampleList = _.cloneDeep(selectedIcdList);
        if (isChecked) {
            updatedSampleList?.push(icdCode);
        } else {
            const icdID = icdCode?.id;
            updatedSampleList?.splice(updatedSampleList?.findIndex(item => item?.id === icdID), 1);
        }
        setSelectedIcdList(updatedSampleList);
        const icdCodes = updatedSampleList.map((item) => item?.id)
        formikRef?.current && formikRef?.current?.setFieldValue("icdCodes", icdCodes)
    }, [selectedIcdList]);

    const onSubmit = useCallback((values: any, {setSubmitting, setErrors, validateForm}: FormikHelpers<any>) => {
        const payload = _.cloneDeep(values);
        if (!payload.isIcdCodeRequired) {
            payload.icdCodes = []
        }
        delete payload.searchString;
        CommonService._test.addTestIcdCode(testID, payload)
            .then((response: any) => {
                setSubmitting(false);
                next(response?.data);
            }).catch((error: any) => {
            setSubmitting(false);
            CommonService._alert.showToast(error?.response?.data?.message, 'error');
        })
    }, [next, testID]);

    useEffect(() => {
        setInitialFormValue((prev) => {
            return {
                ...prev,
                isIcdCodeRequired: testDetails?.isIcdCodeRequired || false,
                icdCodes: testDetails?.icdCodes || []
            }
        })
        setSelectedIcdList(testDetails?.icdCodesDetails || [])
    }, [testDetails]);
    return (
        <div className={'test-report-add-screen screen t-form-screen test-icd-code-step'}>
            <FormTitleWithNavigationBack
                title={'ICD Codes'}
                tooltipData={"ICD Codes of test panel"}
                handleClick={prev}
            />
            <div className="t-form attachments-with-title-wrapper">
                <Formik
                    validationSchema={testIcdValidationSchema}
                    initialValues={initialFormValue}
                    validateOnChange={false}
                    validateOnBlur={true}
                    enableReinitialize={true}
                    validateOnMount={true}
                    innerRef={formikRef}
                    onSubmit={onSubmit}
                >
                    {({isSubmitting, values, isValid, setFieldValue, touched, errors, validateForm}) => {
                        // eslint-disable-next-line react-hooks/rules-of-hooks
                        useEffect(() => {
                            validateForm();
                        }, [validateForm, values]);

                        return (
                            <Form className={"test-panel-configuration-add-holder"}>
                                {/*{JSON.stringify(values)}*/}
                                <div className="t-form-controls-wrapper">
                                    <div className="d-flex align-items-center mrg-bottom-25">
                                        <div className="radio-button-title">Is ICD code required?</div>
                                        <Field
                                            name={'isIcdCodeRequired'}>
                                            {
                                                (field: FieldProps) => (
                                                    <FormikRadioButtonGroupComponent
                                                        direction={"row"}
                                                        isValueBoolean={true}
                                                        titleKey={'title'}
                                                        valueKey={'code'}
                                                        options={CommonService._staticData.yesNoOptions}
                                                        formikField={field}
                                                    />
                                                )
                                            }
                                        </Field>
                                    </div>
                                    {/*<div className={'horizontal-line'}></div>*/}
                                    {
                                        values.isIcdCodeRequired && (
                                            <>
                                                {/*<FormSubTitleWithTooltipComponent title={"All Linked ICD Codes"}/>*/}
                                                <Grid container spacing={2} alignItems={"center"}>
                                                    <Grid item md={6} lg={6}>
                                                        <Field name={"searchString"}>
                                                            {
                                                                (field: FieldProps) => (
                                                                    <SearchComponent label={""}
                                                                                     disabled={values.icdCodes.length < 1}
                                                                                     placeholder={"Search ICD Codes"}
                                                                                     onChange={(e) => {
                                                                                         setFieldValue("searchString", e)
                                                                                     }}
                                                                    />
                                                                )
                                                            }
                                                        </Field>
                                                    </Grid>
                                                    <Grid item md={3} lg={3}>
                                                        <ButtonComponent
                                                            color={"secondary"}
                                                            variant={"outlined"}
                                                            handleClick={() => setIsDrawerOpen(true)}
                                                        >
                                                            Link ICD Code
                                                        </ButtonComponent>
                                                    </Grid>
                                                </Grid>
                                            </>
                                        )
                                    }
                                    {
                                        values?.isIcdCodeRequired && values.icdCodes.length > 0 && (
                                            <div className={'t-table-container mrg-top-25'}>
                                                <TableV2Component
                                                    columns={selectedTableColumns}
                                                    data={values.searchString ? selectedIcdList.filter((item) => item.icdCode.toLowerCase().includes(values.searchString.toLowerCase())) : selectedIcdList}
                                                />
                                            </div>
                                        )
                                    }
                                </div>
                                <div className="form-action-section">
                                    <ButtonComponent
                                        type="button"
                                        color={"primary"}
                                        variant={"outlined"}
                                        fullWidth={true}
                                        disabled={isSubmitting}
                                        handleClick={cancel}
                                    >
                                        Close
                                    </ButtonComponent>

                                    <ButtonComponent
                                        type="submit"
                                        color={"primary"}
                                        variant={"contained"}
                                        fullWidth={true}
                                        disabled={!isValid}
                                        // handleClick={() => {
                                        //     next(values?.list);
                                        // }}
                                        isLoading={isSubmitting}
                                    >
                                        Next
                                    </ButtonComponent>
                                </div>
                            </Form>
                        )
                    }}
                </Formik>
            </div>
            <DrawerComponent
                className={"drawer-wrapper test-icd-code-drawer"}
                // title={'Lab Details'}
                open={isDrawerOpen}
                onClose={() => {
                    setIsDrawerOpen(false);
                }}
            >
                <div className="drawer-sub-header horizontal-vertical-center-align">
                    <HeadingComponent title={"Select ICD Code(s)"}/>
                    <div className={'filters-clear-all-button'}
                         onClick={() => {
                             formikRef?.current && formikRef?.current.setFieldValue("icdCodes", [])
                             setSelectedIcdList([])
                         }}
                    >
                        Clear all
                    </div>
                </div>
                <SearchComponent label={""} placeholder={"Search"} value={drawerTableFilter?.search}
                                 onChange={(e) => setDrawerTableFilter((prev) => {
                                     return {
                                         ...prev,
                                         search: e
                                     }
                                 })}/>
                <div className="table-list-container">
                    <TableWrapperV2Component
                        isPaginated={true}
                        columns={columns}
                        url={APIConfig.GET_ICD_CODE_LIST_TABLE.URL}
                        method={APIConfig.GET_ICD_CODE_LIST_TABLE.METHOD}
                        extraPayload={drawerTableFilter}
                        isColumnFilterVisible={true}
                        // onDataLoad={(data: any) => setData(data)}
                    />
                </div>
            </DrawerComponent>
        </div>
    );

};

export default TestIcdCodesComponent;
